module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "divider weex-ct weex-div",
    style: ({
      width: _vm._px2rem(this.width ? this.width + 'px' : '100%', 75)
    }),
    attrs: {
      "weex-type": "div"
    }
  })
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-79ab3b94", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79ab3b94","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-divider/index.vue
// module id = 632
// module chunks = 0 1